import { normalize, schema } from 'normalizr'
import Vue from 'vue'

import { Api } from '@/utils/Api'
import UrlStore from '@/utils/UrlStore'
import setEntities from '@/utils/SetEntities'

export const BUILDINGS_LOAD = 'BUILDINGS_LOAD'
export const BUILDING_CREATE = 'BUILDING_CREATE'
export const BUILDING_UPDATE = 'BUILDING_UPDATE'
export const BUILDING_DESTROY = 'BUILDING_DESTROY'
export const BUILDING_STATE_UPDATE = 'BUILDING_STATE_UPDATE'

const buildingsApi = new Api(UrlStore.BUILDINGS)
const buildingSchema = new schema.Entity('buildings')

export default {
  namespaced: true,
  state: {
    buildingsLoaded: false,
    buildingsList: [],
    entities: {
      buildings: {}
    }
  },
  getters: {
    buildings(state) {
      return state.buildingsList.map((bId) => state.entities.buildings[bId])
    },
    getBuilding: (state) => (buildingId) => state.entities.buildings[buildingId] || null
  },
  mutations: {
    [BUILDINGS_LOAD](state, payload) {
      let normData = normalize(payload.items, [buildingSchema])
      state.buildingsList = normData.result
      setEntities(state, normData)
    },
    [BUILDING_CREATE](state, building) {
      state.buildingsList.push(building.id)
      Vue.set(state.entities.buildings, building.id, building)
    },
    [BUILDING_UPDATE](state, building) {
      if (building.id && state.entities.buildings[building.id]) {
        state.entities.buildings[building.id] = Object.assign({}, state.entities.buildings[building.id], building)
      }
    },
    [BUILDING_DESTROY](state, building) {
      let num = state.buildingsList.findIndex((cId) => cId === building.id)
      if (num !== -1) {
        state.buildingsList.splice(num, 1)
        delete state.entities.buildings[building.id]
      }
    },
    [BUILDING_STATE_UPDATE](state, data) {
      for (let name of Object.keys(data)) {
        state[name] = data[name]
      }
    }
  },
  actions: {
    buildingsLoad({ commit }, config = {}) {
      buildingsApi.getAll(config).then((r) => {
        commit(BUILDINGS_LOAD, r.data)
        commit(BUILDING_STATE_UPDATE, { buildingsLoaded: true })
      })
    },
    buildingSave({ commit, getters }, building) {
      if (!building.id) throw new Error('Building id is not present in `buildingSave`!')
      commit(getters.getBuilding(building.id) ? BUILDING_UPDATE : BUILDING_CREATE, building)
      let buildingUpdated = getters.getBuilding(building.id)

      return buildingsApi.save(buildingUpdated).then((r) => {
        if (r._isNew) {
          commit(BUILDING_DESTROY, buildingUpdated) // local
          commit(BUILDING_CREATE, r.data)
        } else {
          commit(BUILDING_UPDATE, r.data)
        }
        return r.data.id
      })
    },
    buildingDestroy({ commit }, building) {
      buildingsApi.destroy({ id: building.id }).then(() => {
        commit(BUILDING_DESTROY, building)
      })
    }
  }
}
